(function ($) {
  Drupal.behaviors.tabbedEditorialBlockV1 = {
    attach: function (context) {
      var $module = $('.js-tabbed-editorial-block', context);
      var $contentTriggers = $('.js-tab-trigger', $module);
      var $contentBlocks = $('.js-tab-content', $module);

      $contentTriggers.on('click', function (event) {
        event.preventDefault();
        var index = $(this).index();
        var $activeBlock = $contentBlocks.eq(index);

        // Show this tab content
        $contentBlocks.addClass('hidden');
        $activeBlock.removeClass('hidden');
        $contentTriggers.not(this).removeClass('active');
        $(this).addClass('active');
        // detect for grid elements inside the tab, re-init equalgeights on tab change
        var $GridContent = $('.js-grid-formatter', $activeBlock);

        if ($GridContent.length) {
          $GridContent.find('.js-grid-formatter-item').matchHeight();
        }
      });
    }
  };
})(jQuery);
